module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "linespace"
  }), _vm._v(" "), _c('p', {
    staticClass: "cpytxt"
  }, [_c('a', {
    attrs: {
      "id": "page_iv"
    }
  }), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("LAST DOG ON THE HILL")]), _vm._v(". Copyright © 2010 by Steve Duno. All rights reserved. Printed in the United States of America. For information, address St. Martin’s Press, 175 Fifth Avenue, New York, N.Y. 10010.")]), _vm._v(" "), _c('p', {
    staticClass: "cpytxt1"
  }, [_c('a', {
    attrs: {
      "href": "http://www.stmartins.com",
      "target": "_blank"
    }
  }, [_vm._v("www.stmartins.com")])]), _vm._v(" "), _c('p', {
    staticClass: "cpytxt1"
  }, [_vm._v("Design by Kathryn Parise")]), _vm._v(" "), _c('p', {
    staticClass: "cpytxt1"
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("LIBRARY OF CONGRESS CATALOGING-IN-PUBLICATION DATA")])]), _vm._v(" "), _c('p', {
    staticClass: "cpytxt2"
  }, [_vm._v("Duno, Steve.")]), _vm._v(" "), _c('p', {
    staticClass: "cpytxt3"
  }, [_vm._v(" Last dog on the hill : the extraordinary life of Lou / Steve Duno.—1st ed.")]), _vm._v(" "), _c('p', {
    staticClass: "cpytxt3"
  }, [_vm._v("      p. cm.")]), _vm._v(" "), _c('p', {
    staticClass: "cpytxt3"
  }, [_vm._v(" ISBN 978-0-312-60049-5")]), _vm._v(" "), _c('p', {
    staticClass: "cpytxt3"
  }, [_vm._v("1. Dogs—Anecdotes. 2. Dog owners—Anecdotes. 3. Human-animal"), _c('br'), _vm._v("relationships—Anecdotes. 4. Dogs—Behavior. I. Title.")]), _vm._v(" "), _c('p', {
    staticClass: "cpytxt3"
  }, [_vm._v(" SF426.2.D865 2010")]), _vm._v(" "), _c('p', {
    staticClass: "cpytxt3"
  }, [_vm._v(" 636.7092'9—dc22")]), _vm._v(" "), _c('p', {
    staticClass: "cpytxt4"
  }, [_vm._v("2009047031")]), _vm._v(" "), _c('p', {
    staticClass: "cpytxt1"
  }, [_vm._v("First Edition: June 2010")]), _vm._v(" "), _c('p', {
    staticClass: "cpytxt1"
  }, [_vm._v("10  9  8  7  6  5  4  3  2  1")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-662c7b76","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/copyright.vue
// module id = 72
// module chunks = 0